import * as React from 'react';
import { mdiCheckCircle, mdiCloseCircle } from '@mdi/js';
import {
  isAdminUser,
  isContainLowerCase,
  isContainNumber,
  isContainSpecialChar,
  isContainUpperCase,
  isMaxLength25,
  isMinLength8,
} from '../../services/UtilService';
import Icon from '@mdi/react';
import { THEME } from '../../utils/Styles';
import { MessageBar, MessageBarType } from 'office-ui-fabric-react';

interface IPasswordProps {
  password: string;
  isAdmin?: boolean;
}

const PasswordPolicy: React.FC<IPasswordProps> = ({ password, isAdmin }) => {
  let adminUser = isAdmin;
  if (adminUser === undefined) {
    adminUser = isAdminUser();
  }
  return (
    <>
      <MessageBar messageBarType={MessageBarType.warning} isMultiline={true}>
        {/* <fieldset className="field-set-usable-capacity"> */}
        <div className='p-header'>A password is valid if it contains:</div>
        <div className='p-content'>
          <div>
            {isContainUpperCase(password) ? (
              <Icon
                path={mdiCheckCircle}
                size={0.8}
                className='pointer'
                color={'#2E7D32'}
              />
            ) : (
              <Icon
                path={mdiCloseCircle}
                size={0.8}
                className='pointer'
                color={'#cc3300'}
              />
            )}
            &nbsp;At least 1 uppercase character.
          </div>
          <div>
            {isContainLowerCase(password) ? (
              <Icon
                path={mdiCheckCircle}
                size={0.8}
                className='pointer'
                color={'#2E7D32'}
              />
            ) : (
              <Icon
                path={mdiCloseCircle}
                size={0.8}
                className='pointer'
                color={'#cc3300'}
              />
            )}
            &nbsp;At least 1 lowercase character.
          </div>
          <div>
            {isContainNumber(password) ? (
              <Icon
                path={mdiCheckCircle}
                size={0.8}
                className='pointer'
                color={'#2E7D32'}
              />
            ) : (
              <Icon
                path={mdiCloseCircle}
                size={0.8}
                className='pointer'
                color={'#cc3300'}
              />
            )}
            &nbsp;At least 1 digit.
          </div>
          <div>
            {isContainSpecialChar(password) ? (
              <Icon
                path={mdiCheckCircle}
                size={0.8}
                className='pointer'
                color={'#2E7D32'}
              />
            ) : (
              <Icon
                path={mdiCloseCircle}
                size={0.8}
                className='pointer'
                color={'#cc3300'}
              />
            )}
            &nbsp;At least 1 special character.
          </div>
          <div>
            {isMinLength8(password, adminUser) ? (
              <Icon
                path={mdiCheckCircle}
                size={0.8}
                className='pointer'
                color={'#2E7D32'}
              />
            ) : (
              <Icon
                path={mdiCloseCircle}
                size={0.8}
                className='pointer'
                color={'#cc3300'}
              />
            )}
            &nbsp;Minimum {adminUser ? "14" : "10"} characters.
          </div>
          <div>
            {isMaxLength25(password) ? (
              <Icon
                path={mdiCheckCircle}
                size={0.8}
                className='pointer'
                color={'#2E7D32'}
              />
            ) : (
              <Icon
                path={mdiCloseCircle}
                size={0.8}
                className='pointer'
                color={'#cc3300'}
              />
            )}
            &nbsp;Maximum 25 characters.
          </div>
        </div>
        {/* </fieldset> */}
      </MessageBar>
    </>
  );
};

export default PasswordPolicy;
